import { put, takeEvery } from 'redux-saga/effects'
import cookie from 'react-cookie'
import {
  INIT_APP_PARAMS,
  APP_PARAMS_INITIALIZED,
  APP_PARAMS_ERROR,
} from '../actions/index'

function* onAppInit(action) {
  const { payload } = action
  if (!payload.site && !cookie.load('site')) {
    yield put({
      type: APP_PARAMS_ERROR,
      payload: {
        message: 'ERROR_MISSING_SITE_PARAMETER',
      },
    })
  } else {
    cookie.save('site', payload.site || cookie.load('site'), { maxAge: 600 })

    yield put({
      type: APP_PARAMS_INITIALIZED,
      payload: {
        site: payload.site || cookie.load('site'),
        locale: payload.locale || null,
      },
    })
  }
}

export default function* initApp() {
  yield takeEvery(INIT_APP_PARAMS, onAppInit)
}



// WEBPACK FOOTER //
// ./src/sagas/init-app.js